import { render, staticRenderFns } from "./search-filters-block.vue?vue&type=template&id=3c345573"
import script from "./search-filters-block.vue?vue&type=script&lang=ts"
export * from "./search-filters-block.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports